import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogTitle, CircularProgress } from '@material-ui/core';
import ComponentSection from './ComponentSection'
import { checkApiStatus } from '../../../utils_v2';
import { globalPutService, globalPostService } from '../../../utils_v2/globalApiServices';
import AddIcon from '@material-ui/icons/Add';

const ComponentFields = ({params, componentFields, toggleModalFn, getResponseBack, getCurrentFormDetail}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [componentSections, setComponentSections] = useState(componentFields.data)
    const [fieldsError, setFieldsError] = useState({sectionsError:[]});
    const getDuplicateIndexes = (strArray) => {
        const values = strArray.map(item => item?.trim()?.toLowerCase() || '')
        return values.map((item, index) => item !== '' && values.some((value, valueIndex) => valueIndex !== index && value === item))
    }
    const onFieldChange = (value, key, sectionIndex, questionIndex=null) => {
        if(questionIndex !== null){
            setComponentSections(componentSections.map((section, index) => index !== sectionIndex ? section : {
                ...section, question_answers:section.question_answers.map((item, itemIndex) => questionIndex !== itemIndex ? item : {...item, [key]:value})
            }))
        }else{
            setComponentSections(componentSections.map((section, index) => index !== sectionIndex ? section : {...section, [key]:value}))
        }
    }
    const onAddRemoveFields = (type, sectionIndex, questionIndex) => {
        if(type === 'add'){
            setComponentSections(componentSections.map((section, index) => index !== sectionIndex ? section:{...section , question_answers: [...section.question_answers, {label:'',value:''}]}))
        }else{
            setComponentSections(componentSections.map((section, index) => index !== sectionIndex ? section : {...section, question_answers:section.question_answers.filter((item, itemIndex) => itemIndex !== questionIndex)}))
            setFieldsError({...fieldsError, sectionsError:fieldsError.sectionsError.map((section, index) => index !== sectionIndex ? section : {
                ...section, questionsError:section.questionsError?.filter((item, itemIndex) => itemIndex !== questionIndex)
            })})
        }
    }
    const onAddRemoveSection = (type, sectionIndex) => {
        if(type === 'add'){
            const section = {title:'',order:componentSections.length+1, inspection_asset_section:componentFields.sectionId,question_answers:[{label:'', value:''}]}
            setComponentSections([...componentSections, section])
        }else{
            setComponentSections(componentSections.filter((section, index) => index !== sectionIndex))
            setFieldsError({...fieldsError, sectionsError:fieldsError.sectionsError.filter((section, index) => index !== sectionIndex)})
        }
    }
    const onUpdateComponentFields  = () => {
        let titleDuplicates = getDuplicateIndexes(componentSections.map(item => item?.title));
        let compErrors = componentSections.map((item, sectionIndex) => {
            let labelDuplicates = getDuplicateIndexes(item.question_answers.map(question => question?.label));
            return {
                title: titleDuplicates[sectionIndex] ? 'Section name already exists' : '',
                questionsError: item.question_answers.map((question, questionIndex) => {
                    return {label: !question?.label?.trim()?.length ? 'Please enter Label' : labelDuplicates[questionIndex] ? 'Label already exists' : ''}
                })
            }
        });
        let isError = compErrors.some(section => section.title || section.questionsError.some(question => question.label));
        if(isError){
            setFieldsError({sectionsError:compErrors});
            enqueueSnackbar('Data validation error in component fields', { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
        }else{
            globalPostService(`technical/v2/workorder/${params.workOrderSlug}/${componentFields.sectionId}/asset-sections-components/?asset_type=${params.type}`, componentSections)
            .then(response => {
                if(checkApiStatus(response)){
                    enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    toggleModalFn();getResponseBack(response.data.data);
                    getCurrentFormDetail()
                }else{
                    enqueueSnackbar(response.data.message, { variant: 'error',anchorOrigin:{horizontal:'right', vertical:'top'}});
                }
            })
        }
    }
    const onResetError = (key,sectionIndex, questionIndex) => {
        setFieldsError({...fieldsError, sectionsError:fieldsError.sectionsError.map((section, secIndex) => secIndex !== sectionIndex ? section : key === 'section' ? {...section, title:''} : {
            ...section, questionsError:section.questionsError.map((qus, qIndex) => qIndex !== questionIndex ? qus:{
                ...qus, [key]:''
            })
        })})
    }
    return(
        <Dialog
            open={componentFields.modal}
            onClose={toggleModalFn}
            className='project-management-modal'
            maxWidth='lg'
        >
            <DialogTitle id="scroll-dialog-title">
                {componentFields.mode === 'add' ? 'Add':'Edit'} Component Fields
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={12}>
                        <div style={{marginBottom:'10px', textAlign:'right'}}>
                            <Button onClick={(e) => {onAddRemoveSection('add'); componentSections.length > 2 ? enqueueSnackbar('Section added, scroll to bottom', { variant: 'info',anchorOrigin:{horizontal:'right', vertical:'top'}}):e.preventDefault();}} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />Add Section</Button>
                        </div>
                        <div className='t004-component-fields-modal' style={{width:'580px'}}>
                            {componentSections.map((section, sectionIndex) => 
                                <ComponentSection 
                                    sectionError={fieldsError?.sectionsError?.length && fieldsError?.sectionsError[sectionIndex] ? fieldsError?.sectionsError[sectionIndex]:{}}
                                    section={section}
                                    sectionIndex={sectionIndex}
                                    onAddRemoveSection={onAddRemoveSection}
                                    onAddRemoveFields={onAddRemoveFields}
                                    onFieldChange={onFieldChange}
                                    onResetError={(key, questionIndex) => onResetError(key, sectionIndex, questionIndex)}
                                />
                            )}
                        </div>
                    </Grid>
                </Grid>
                
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size="small" variant="outlined">Cancel</Button>
                {/* { componentSections.length ? */}
                    <Button disabled={isLoading} onClick={onUpdateComponentFields} color='primary' size="small" variant="contained">
                        {isLoading ? <CircularProgress size={24} />:'Save'}
                    </Button>
                {/* } */}
            </DialogActions>
        </Dialog>
    )
}

export default withRouter(ComponentFields);